import React,{useContext,useEffect, useState, useRef,useCallback, useMemo} from 'react';
import { DatabaseContext } from '../../redux/DatabaseStore';
import { useFormik } from 'formik';
import { getRequest, postRequest, deleteRequest, tabulatorGet } from '../../api/ApiController';
import { AddIcon, CopyIcon, VerticalLineIcon, BackToFirstIcon, BackIcon, ForwardIcon, ForwardToLastIcon, FavoriteIcon, PriceIcon, EditRowIcon, PaperClipIcon, EditIcon, DeleteIcon, RefreshIcon } from "../svg/svgIcons";
import { Dialog } from 'primereact/dialog';
import AuthContext from '../../components/AuthContext';
import UtilContext from '../../components/UtilContext';
import { Splitter, SplitterPanel } from 'primereact/splitter';
import { ReactTabulator,reactFormatter } from 'react-tabulator';
import { DateTime } from "luxon";
import { OverflowMenuProvider } from '../../components/toolbar/OverflowMenu';
import { confirmDialog } from 'primereact/confirmdialog';
import { PanelMenu } from 'primereact/panelmenu';
import { Checkbox } from 'primereact/checkbox';
import { InputTextarea } from 'primereact/inputtextarea';
import { RadioButton } from 'primereact/radiobutton';
import IntersectionObserverWrapper from '../../components/toolbar/IntersectionObserverWrap';
import { Accordion, AccordionTab } from 'primereact/accordion';
import { Avatar } from 'primereact/avatar';
import { getTimezone } from '../../utils/moduleSettings';
import { ExecutionDeadlineFormatter, executionDeadlineFilter } from "./ChecklistExecutionDeadline";
import { createArrayNavigateHandlers } from '../../utils/arrayNavigate';
import { cleanSorters, parseSorters, parseMaskFilters, safeParse, extractSafePaginationParams, createDedupedAjaxRequest, refreshProgressiveFromStart } from '../../utils/tabulatorProgressiveLoading';
import { scrollToFirst as scrollToFirstUtil, scrollUp as scrollUpUtil, scrollDown as scrollDownUtil, scrollToLast as scrollToLastUtil } from '../../utils/tabulatorScroll';
import { getPusherChannel } from '../../utils/pusherChannel';
import { primeMultiSelectHeaderFilter } from '../../utils/primeMultiSelectHeaderFilter';
import { resetTabulatorMask } from '../../utils/tabulatorResetMask';
import { LocaleContext } from '../../components/LocaleContext';
import { defaultProductLogoSrc } from '../../constants/brandingDisplay';
import { buildCanonicalPrintFooterHtml, buildCanonicalPrintHeaderHtml } from '../../utils/printChrome';
import { canCreateChecklistRecord, interpretChecklistRecordCreateResponse, interpretChecklistRecordCreateTransportError } from '../../utils/checklistRecordCreateHttp';
export default function ChecklistRecordAdd({checklist_template, type, original_user_id}) {

    const [state,dispatch] = useContext(DatabaseContext);
    const {setDialogText,setVisible,openFavoriteDialog,toast,setFastView,setUserMaskFilter,formatID,getUserInitials,getUserColor,openFilePreview,getDateFormat,formatDate, openChosenNotificationPreferences} = useContext(UtilContext);
    const dateFmt = getDateFormat?.() ?? "dd.MM.yyyy";
    const dateTimeFmt = `${dateFmt} HH:mm`;
    const timezone = getTimezone(state?.module_settings || []);
    const {user} = useContext(AuthContext);
    const { t } = useContext(LocaleContext);
    const canCreate = canCreateChecklistRecord(user);

    const [closeTab,setCloseTab] = useState(false);
    const ref = useRef(null);
    const overlayRef = useRef(null);

    const [formChecklistTemplate,setFormChecklistTemplate] = useState(checklist_template);
    const [showRecordAdd, setShowRecordAdd] = useState(false);

    const [markUnmark, setMarkUnmarked] = useState(true);

    const DEFAULT_COLUMNS_VISIBLE_ADD = { id: true, name: true, custom_department: true, created_at: true, user_update_at: true, execution_deadline: true, status: true, process_status: true, manager_name: true, deadline: true, manager_response: true, manager_status: true, checklist_status: true };
    const [columnsVisible, setColumnsVisible] = useState({ ...DEFAULT_COLUMNS_VISIBLE_ADD });
    const [maskVisible, setMaskVisible] = useState(false);
//TODO dorobit contractor id
    const [scrollIcons,setScrollIcons] = useState(!canCreate);
    const [editIcon,setEditIcon] = useState(true);
    const [deleteIcon,setDeleteIcon] = useState(true);
    const [copyIcon,setCopyIcon] = useState(true);
    
    const [selectedRecord,setSelectedRecord] = useState(null);

    const [visibleRecord,setVisibleRecord] = useState(false);

    const [images,setImages] = useState([]);

    const tableBuiltRef = useRef(false);
    const userInteractedRef = useRef(false);
    const useMaskDefaultsRef = useRef(true);
    const inFlightRef = useRef({ sig: null, promise: null });
    const completedCacheRef = useRef(new Map());
    const pagingRef = useRef({ current: 1, last: 1 });
    const savedHScrollRef = useRef({ left: 0, pending: false });
    const getTable = useCallback(() => ref.current?.table ?? ref.current, []);
    const refreshFromStart = useCallback(() => refreshProgressiveFromStart(getTable, completedCacheRef, t('Common.LoadingData')), [getTable]);

    const captureHScroll = () => {
      const table = ref.current;
      if (!table) return;
      const holder = table.rowManager?.element;
      if (!holder) return;
      savedHScrollRef.current = { left: holder.scrollLeft, pending: true };
    };

    const restoreHScroll = () => {
      if (!savedHScrollRef.current.pending) return;
      const table = ref.current;
      if (!table) return;
      const holder = table.rowManager?.element;
      const header = table.columnManager?.contentsElement;
      if (!holder) return;
      const left = savedHScrollRef.current.left;
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          holder.scrollLeft = left;
          if (header) header.scrollLeft = left;
          savedHScrollRef.current.pending = false;
        });
      });
    };

    const templateId = formChecklistTemplate?.id ?? checklist_template?.id;

    const buildRequestParams = useCallback((paramsFromTabulator = {}) => {
        const extra = { ...extractSafePaginationParams(paramsFromTabulator) };
        if (templateId) extra.filter_checklist_template_id = templateId;

        const t = ref.current;
        const tableReadyForParams = tableBuiltRef.current;
        const hf = t?.getHeaderFilters?.() ?? [];

        if (tableReadyForParams) {
            hf.forEach(f => {
                if (f?.field === undefined) return;
                const rawVal = f.value;
                const isEmpty = rawVal === undefined || rawVal === null || String(rawVal).trim() === "";
                let vStr = isEmpty ? "" : String(rawVal).trim();
                if (!isEmpty && f.field === "checklist_status") {
                    const parts = vStr.split(",").map(x => x.trim()).filter(Boolean);
                    if (parts.length === 0 || parts.length >= 3) vStr = "";
                    else vStr = parts.join(",");
                }
                let filterKey = f.field === "template.machine.name" ? "filter_template_machine_name" : (f.field === "id" ? "filter_id" : `filter_${f.field}`);
                if (!isEmpty && f.field === "created_at" && /^[\d,\s]+$/.test(vStr)) filterKey = "filter_user_id";
                else if (!isEmpty && f.field === "manager_name" && /^[\d,\s]+$/.test(vStr)) filterKey = "filter_template_manager_id";
                extra[filterKey] = f.field === "is_unread" ? (isEmpty ? "" : String(rawVal)) : vStr;
            });
            const dateFilterFields = ["created_at", "user_update_at", "updated_at", "manager_name", "deadline", "execution_deadline"];
            const hasDateFilter = hf.some(f => f?.field && dateFilterFields.includes(f.field) && String(f?.value ?? "").trim() !== "");
            if (hasDateFilter) extra.filter_date_format = getDateFormat?.() ?? "dd.MM.yyyy";
            const sortersFromTable = t?.getSorters?.() ?? [];
            if (Array.isArray(sortersFromTable) && sortersFromTable.length > 0) {
                const mapSorterFieldForApi = (s) => ({ ...s, field: (s.field === "id" ? "id" : s.field) });
                const clean = cleanSorters(sortersFromTable).map(mapSorterFieldForApi);
                if (clean.length > 0) extra.sorters = JSON.stringify(clean);
            }
        } else if (!tableReadyForParams && useMaskDefaultsRef.current && state.user_mask_filters) {
            const maskRow = state.user_mask_filters.find(m => m.page === "ChecklistRecordAdd");
            if (maskRow) {
                parseMaskFilters(maskRow.filters).forEach(f => {
                    if (!f?.field) return;
                    const v = f.value;
                    if (v === undefined || v === null || String(v).trim() === "") return;
                    let filterKey = f.field === "template.machine.name" ? "filter_template_machine_name" : `filter_${f.field}`;
                    if (f.field === "created_at" && /^[\d,\s]+$/.test(String(v || ""))) filterKey = "filter_user_id";
                    else if (f.field === "manager_name" && /^[\d,\s]+$/.test(String(v || ""))) filterKey = "filter_template_manager_id";
                    extra[filterKey] = f.field === "is_unread" ? String(v) : v;
                });
                const parsedSorters = parseSorters(maskRow.sorters).map(s => ({ ...s, field: (s.field === "id" ? "id" : s.field) }));
                if (parsedSorters.length > 0) extra.sorters = JSON.stringify(parsedSorters);
            }
        }
        return extra;
    }, [templateId, state.user_mask_filters]);

    const [pendingSubmit, setPendingSubmit] = useState(null);

    useEffect(() => {
        // Update the document title using the browser API
        if(selectedRecord!=null){
            //getImages();
            //console.log(selectedRecord);
        }
    },[selectedRecord]);

    function getRecordFiles(id){
        getRequest(`/api/checklist_records/protocols/${id ? id : selectedRecord?.id}`).then((response) => {
            if(response.data!=="{}"){
                setImages(response.data);
                formikUpdate?.setFieldValue('files',response.data);
            }
        });
    }

    function addChecklistRecord(){
        if (!canCreate) return;
        setShowRecordAdd(true);
    }
      
    function copyChecklistRecord(){
        formik.setValues(ref.current.getSelectedData()[0]);
        setShowRecordAdd(true); 
    }

    function editChecklistRecord(){
        formikUpdate.setValues(ref.current.getSelectedData()[0]);
        getRecordFiles(ref.current.getSelectedData()[0]?.id);
        setVisibleRecord(true);
    }

    function hideEditRecord(){
        formikUpdate.resetForm();
        setSelectedRecord(null);
        setImages([]);
        setVisibleRecord(false);
    }

    const validate = (values, checklist_template, formik_type) => {
        const errors = {};

        if (values.save_mode === 'save') {
            values.answers?.forEach((answer, idx) => {
                const qErrors = {};
                if (!answer) return;

                const rawModes = checklist_template?.questions?.[idx]?.answer_modes;
                const answer_modes = rawModes
                ? (typeof rawModes === "string" ? JSON.parse(rawModes) : rawModes)
                : {};

                // 1. OK/NOK/NO povinné, ak answer_modes.okNok je true
                if (answer_modes.okNok) {
                    if (!['ok', 'nok', 'no'].includes(answer.okNokAnswer)) {
                        qErrors.okNokAnswer = t('Checklist.SelectOKNOKNO');
                    }

                    // Poznámky k OK
                    if (answer.okNokAnswer === 'ok' && answer_modes.okNote && !answer.okNote) {
                        qErrors.okNote = t('Checklist.NoteOKRequired');
                    }

                    // Poznámky k NOK
                    if (answer.okNokAnswer === 'nok' && answer_modes.nokNote && !answer.nokNote) {
                        qErrors.nokNote = t('Checklist.NoteNOKRequired');
                    }

                    // Ak je zvolené NO a zároveň answer_modes.noNote, potom validuj poznámku
                    if (answer.okNokAnswer === 'no' && answer_modes.noNote && !answer.noNote) {
                        qErrors.noNote = t('Checklist.NoteNORequired');
                    }
                }

                const isNoSelected = answer.okNokAnswer === 'no';

                // 2. Meno povinné podľa answer_modes.name (ale len ak nie je zvolený NO)
                if (answer_modes.name && !answer.employeeId && !isNoSelected) {
                    qErrors.employeeId = t('Checklist.EmployeeRequired');
                }

                // 3. Fotky povinné podľa answer_modes.photo (ale len ak nie je zvolený NO)
                if (answer_modes.photo && !isNoSelected) {
                    if (formik_type === 'insert') {
                        // pri vytváraní záznamu musí byť aspoň jedna nahratá fotka
                        const hasUploadedPhotos = answer.photos && answer.photos.length > 0;
                        if (!hasUploadedPhotos) {
                            qErrors.photos = t('Checklist.PhotoRequired');
                        }
                    }

                    if (formik_type === 'update') {
                        const hasUploadedPhotos = answer.photos && answer.photos.length > 0;

                        const hasExistingPhotos = Array.isArray(images)
                            ? images.some(file => String(file?.question_id) === String(idx))
                            : false;

                        if (!hasUploadedPhotos && !hasExistingPhotos) {
                            qErrors.photos = t('Checklist.PhotoRequired');
                        }
                    }
                }

                // 4. Ak je zvolený NO, ale sú pridané fotky → chyba
                if (isNoSelected && answer.photos && answer.photos.length > 0) {
                    qErrors.photos = t('Checklist.NoPhotoForNO');
                }

                if (Object.keys(qErrors).length > 0) {
                    if (!errors.answers) errors.answers = [];
                    errors.answers[idx] = qErrors;
                }
            });
        }
        console.log('VALIDATION ERRORS', errors);
        return errors;
    };


    const formik = useFormik({
            initialValues: {
                name: '',
                answers: checklist_template?.questions?.map(() => ({
                    okNokAnswer: '',  // 'ok' alebo 'nok'
                    okNote: '',       // poznámka k OK
                    nokNote: '', 
                    noAnswer: false,
                    noNote: '',
                    photos: [],
                    employeeId: '',
                })) || [],
                save_mode: 'save',
            },
            validate: values => validate(values, checklist_template,"insert"),
            onSubmit: values => {
                setDialogText(t('Common.SavingEllipsis'));
                setVisible(true);
                let finalName = values.name?.trim();
                if (!finalName) {
                    finalName = "by_system";
                }
                const formData = new FormData();
                for (let key in values) {
                    const value = values[key];

                    if (key === 'answers' && Array.isArray(value)) {
                        // Najskôr odstránime súbory z answer objektov, aby sme ich odoslali ako JSON string
                        const answersWithoutFiles = value.map(answer => {
                            const answerCopy = { ...answer };
                            delete answerCopy.photos; // odstrániť súbory z JSONu
                            return answerCopy;
                        });
                        formData.append('answers', JSON.stringify(answersWithoutFiles));
                        // Teraz pridáme súbory z answers do FormData zvlášť
                        value.forEach((answer, questionIndex) => {
                            if (answer.photos && answer.photos.length > 0) {
                                // answer.photos je FileList alebo pole súborov
                                for (let i = 0; i < answer.photos.length; i++) {
                                    formData.append(`answers[${questionIndex}][photos][]`, answer.photos[i]);
                                }
                            }
                        });
                    } 
                    else if (typeof value === 'object' && value !== null) {
                        // ostatné objekty ako JSON string
                        formData.append(key, JSON.stringify(value));
                    } 
                    else {
                        formData.append(key, value);
                    }
                }
                // prepíšeme alebo nastavíme názov (ak treba upraviť finalName pred tým)
                formData.set('name', finalName);
                // pridáme id šablóny
                formData.append('checklist_template_id', checklist_template.id);
                if (original_user_id != null && original_user_id !== '') {
                    formData.append('original_user_id', original_user_id);
                }
                postRequest('/api/checklist_records', formData,true)
                .then((response) => {
                    const result = interpretChecklistRecordCreateResponse(response);
                    if (!result.ok) {
                        setVisible(false);
                        const text = result.detail ? result.detail : t(result.messageKey);
                        if (toast?.current?.show) {
                            toast.current.show({ severity: 'error', summary: t(result.messageKey), life: 4000, detail: text });
                        } else {
                            alert(text);
                        }
                        return;
                    }
                    if(closeTab)dispatch({type:'close_tab',id:state.selectedTab});
                    setShowRecordAdd(false);
                    setSelectedRecord(null);
                    setImages([]);
                    formik.resetForm();
                    setVisible(false);
                    refreshFromStart();
                    toast?.current?.show({ severity: 'info', summary: t('ChecklistRecord.Create.RecordSaved'), life: 3000, detail: t('ChecklistRecord.Create.RecordSaved') });
                }).catch(() => {
                    setVisible(false);
                    const result = interpretChecklistRecordCreateTransportError(navigator.onLine);
                    const text = t(result.messageKey);
                    if (toast?.current?.show) {
                        toast.current.show({ severity: 'error', summary: text, life: 4000, detail: text });
                    } else {
                        alert(text);
                    }
                })
            },
        });

        useEffect(() => {
            if (pendingSubmit=="insert") {
                formik.submitForm();
                setPendingSubmit(null);
            }
            else if (pendingSubmit=="update") {
                formikUpdate.submitForm();
                setPendingSubmit(null);
            }
        }, [pendingSubmit]);
    
        const formikUpdate = useFormik({
            initialValues: selectedRecord == null ? {
                name: '',
                answers: selectedRecord?.questions?.map(() => ({
                    okNokAnswer: '',  // 'ok' alebo 'nok'
                    okNote: '',       // poznámka k OK
                    nokNote: '', 
                    noAnswer: false,
                    noNote: '',
                    photos: [],
                    employeeId: '',
                })) || [],
                save_mode: 'save',
            } : {
                ...selectedRecord,
                answers: selectedRecord.answers?.length
                    ? selectedRecord.answers
                    : selectedRecord?.questions?.map(() => ({
                        okNokAnswer: '',
                        okNote: '',
                        nokNote: '',
                        noAnswer: false,
                        noNote: '',
                        photos: [],
                        employeeId: '',
                    })) || [],
                    save_mode: selectedRecord?.save_mode,
                },
            enableReinitialize:true,
            validate: values => validate(values,selectedRecord,"update"),
            onSubmit: values => {
                setDialogText(t('Common.SavingEllipsis'));
                setVisible(true);
                let finalName = values.name?.trim();
                if (!finalName) {
                    finalName = "by_system";
                }
                const formData = new FormData();
                for (let key in values) {
                    const value = values[key];
                    if (key === 'answers' && Array.isArray(value)) {
                        // Najskôr odstránime súbory z answer objektov, aby sme ich odoslali ako JSON string
                        const answersWithoutFiles = value.map(answer => {
                            const answerCopy = { ...answer };
                            delete answerCopy.photos; // odstrániť súbory z JSONu
                            return answerCopy;
                        });
                        formData.append('answers', JSON.stringify(answersWithoutFiles));
                        // Teraz pridáme súbory z answers do FormData zvlášť
                        value.forEach((answer, questionIndex) => {
                            if (answer.photos && answer.photos.length > 0) {
                                // answer.photos je FileList alebo pole súborov
                                for (let i = 0; i < answer.photos.length; i++) {
                                    formData.append(`answers[${questionIndex}][photos][]`, answer.photos[i]);
                                }
                            }
                        });
                    } 
                    else if (typeof value === 'object' && value !== null) {
                        formData.append(key, JSON.stringify(value));
                    } 
                    else {
                        formData.append(key, value);
                    }
                }
                formData.set('name', finalName);
                formData.append('checklist_template_id', checklist_template.id);
                postRequest(`/api/checklist_records/update/${formikUpdate.values.id}`, formData,true)
                .then((response) => {
                    if(closeTab)dispatch({type:'close_tab',id:state.selectedTab});
                    setVisibleRecord(false);
                    setSelectedRecord(null);
                    setImages([]);
                    formikUpdate.resetForm();
                    setVisible(false);
                    refreshFromStart();
                    toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('Common.Toast.RecordSavedDetail') });
                }).catch((reason) => {
                    setVisible(false);
                    if(!navigator.online){
                        alert(t('ServiceTask.OfflineQueuedAlert'));
                    }
                    else{
                        alert(t('Common.Toast.ActionFailedDetail'));
                    }
                });
            },
        });

    const { scrollToFirst, scrollUp, scrollDown, scrollToLast } = useMemo(() => {
        const getItems = () => ref.current?.getData() ?? [];
        return {
            scrollToFirst: () => { const items = getItems(); if (items?.length) setFormChecklistTemplate(items[0]); },
            scrollUp: () => { const items = getItems(); const id = formik.values.id; const i = items.findIndex(x => x?.id == id); if (i > 0) setFormChecklistTemplate(items[i - 1]); },
            scrollDown: () => { const items = getItems(); const id = formik.values.id; const i = items.findIndex(x => x?.id == id); if (i >= 0 && i < items.length - 1) setFormChecklistTemplate(items[i + 1]); },
            scrollToLast: () => { const items = getItems(); if (items?.length) setFormChecklistTemplate(items[items.length - 1]); },
        };
    }, [formik.values.id]);

    const onSelectRow = () => {
        setEditIcon(true);
        setCopyIcon(true);
        setDeleteIcon(true);
        if(ref.current.getSelectedData().length === 1){
            if(user.permissions?.includes("add checklists"))setEditIcon(false);
            if(user.permissions?.includes("delete checklists"))setDeleteIcon(false);
            if(user.permissions?.includes("add checklists"))setCopyIcon(false);
            setSelectedRecord(ref.current.getSelectedData()[0]);
        }
    }

    function onEditRow(record){
        formikUpdate.setValues(record);
        setSelectedRecord(record);
        getRecordFiles(record?.id);
        setVisibleRecord(true);      
    };

    function EditRowFormatter(props) {
      const rowData = props.cell.getRow().getData();
      return <div className='flex items-center justify-center w-full h-full'><button type='button' onClick={() => onEditRow(rowData)}><EditRowIcon/></button></div>;
    }
    
    function removeDiacritics(str) {
        return (str || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    }
    
    function genericFilter(headerValue, rowValue) {
      if (!headerValue) return true;
      if (!rowValue) return false;
      return removeDiacritics(rowValue.toString().toLowerCase()).includes(removeDiacritics(headerValue.toString().toLowerCase()));
    }
    
    const extractDepartmentsFromRecipients = (recipients) => {
          const departmentMap = new Map();
    
          recipients.forEach((user) => {
              const dept = user?.employee?.department;
              if (dept && !departmentMap.has(dept.id)) {
                departmentMap.set(dept.id, {
                    id: dept.id,
                    name: dept.name,
                    searchLabel: removeDiacritics(dept.name).toLowerCase(),
                });
              }
              else if(user?.employee?.department_id){
                let db_dept = state.departments.find(department => department.id == user?.employee?.department_id);
                departmentMap.set(db_dept.id, {
                    id: db_dept.id,
                    name: db_dept.name,
                    searchLabel: removeDiacritics(db_dept.name).toLowerCase(),
                });
              }
          });
    
          return Array.from(departmentMap.values());
      };
    
    function DepartmentFormatter(props) {
        const rowData = props.cell.getRow().getData();
        return extractDepartmentsFromRecipients([rowData?.user]).map(departmnent => departmnent?.name).join(', ');
    }
    
      function departmentFilter(headerValue, rowValue, rowData, filterParams) {
        if (!headerValue) return true;
    
        const search = removeDiacritics(headerValue).toLowerCase();
        const deptId = rowData?.user?.employee?.department_id;
        if (!deptId) return false;
    
        const found = state?.departments.find(d => d?.id == deptId);
        return found ? removeDiacritics(found.name).toLowerCase().includes(search) : false;
      }
    
    const substituteBadgeZ = (
        <span className="p-badge p-badge-info" style={{ position: 'absolute', top: '-2px', right: '-2px', fontSize: '0.75rem', minWidth: '14px', height: '14px', lineHeight: '14px', padding: '0 3px' }}>Z</span>
    );
    function UserFormatter(props) {
        const rowData = props.cell.getRow().getData();
        const isSubstitute = rowData?.is_substitute;
        if(rowData?.process_status== 'Nevytvorený'){
        return <div className='flex items-center justify-start w-full h-full'>
            <Avatar className='p-overlay-badge' title="System" icon="pi pi-database" shape="circle" style={{ backgroundColor: 'grey', color: '#ffffff',marginRight: '5px'}}/>
            <div>{formatDate(rowData.created_at, true)}</div>
        </div>;
        }
        const userAvatar = rowData?.user && (
            <Avatar title={rowData?.user?.employee?.name || rowData?.user?.username} label={getUserInitials(rowData?.user?.employee?.name || rowData?.user?.username)} shape="circle" style={{ backgroundColor: getUserColor(rowData?.user?.username), color: '#ffffff',marginRight: '5px'}} />
        );
        return <div className='flex items-center justify-start w-full h-full' style={{ lineHeight: 1 }}>
            {rowData?.user && <div style={{ lineHeight: 0 }}>
                {isSubstitute ? (
                    <span style={{ position: 'relative', display: 'inline-block' }}>{userAvatar}{substituteBadgeZ}</span>
                ) : (
                    userAvatar
                )}
            </div>}
            <div>{formatDate(rowData.created_at, true)}</div>
        </div>;
    }

    function userFilter(headerValue, rowValue, rowData) {
        if (!headerValue) return true;
        const search = removeDiacritics(headerValue).toLowerCase();

        const isSystem = rowData?.process_status === "Nevytvorený";
        const who = isSystem
            ? "System"
            : (rowData?.user?.employee?.name || rowData?.user?.username || "");

        const when = rowData?.created_at
            ? formatDate(rowData.created_at, true)
            : "";

        const combined = `${who} ${when}`;
        return removeDiacritics(combined).toLowerCase().includes(search);
    }

    function UserUpdateFormatter(props) {
        const rowData = props.cell.getRow().getData();
        const isSubstitute = rowData?.is_substitute;
        if(rowData?.process_status== 'Nevytvorený' || rowData?.process_status== 'Rozpracovaný')return;
        const userAvatar = rowData?.user && (
            <Avatar title={rowData?.user?.employee?.name || rowData?.user?.username} label={getUserInitials(rowData?.user?.employee?.name || rowData?.user?.username)} shape="circle" style={{ backgroundColor: getUserColor(rowData?.user?.username), color: '#ffffff',marginRight: '5px'}} />
        );
        return <div className='flex items-center justify-start w-full h-full' style={{ lineHeight: 1 }}>
            {rowData?.user && <div style={{ lineHeight: 0 }}>
                {isSubstitute ? (
                    <span style={{ position: 'relative', display: 'inline-block' }}>{userAvatar}{substituteBadgeZ}</span>
                ) : (
                    userAvatar
                )}
            </div>}
            <div>{formatDate(rowData.user_update_at, true)}</div>
        </div>;
    }

    function userUpdateFilter(headerValue, rowValue, rowData, filterParams) {
        if (!headerValue) return true; // prázdny filter = všetko
        if (rowData?.process_status === "Nevytvorený" || rowData?.process_status== 'Rozpracovaný') return false;
        const normalize = (str) =>
            (str || "")
                .toString()
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "")
                .toLowerCase();
        const search = normalize(headerValue);
        if (filterParams?.name=="user_update_at" && rowData?.user) {
            const touchedName = rowData.user?.employee?.name || rowData.user?.username;
            if (normalize(touchedName).includes(search)) {
                return true;
            }
        }
        if(filterParams.name=="user_update_at"){
            if(DateTime.fromSQL(rowData.user_update_at).toFormat(dateTimeFmt).includes(headerValue)) return true;
        }
        return false;
    }
    
    function ManagerFormatter(props) {
        const rowData = props.cell.getRow().getData();
        if(rowData?.status === "NOK" && (rowData?.checklist_status || "").toLowerCase() !== "uzavretý")return "";
        const isBotCase = rowData?.status === "OK" && (rowData?.checklist_status || "").toLowerCase() === "uzavretý";
        const timeToShow = isBotCase ? rowData?.user_update_at : rowData?.manager_update_at;
        return (
            <div className="flex items-center justify-start w-full h-full">
            {isBotCase ? (
                <div className="mr-2">
                <Avatar className='p-overlay-badge' title="System" icon="pi pi-database" shape="circle" style={{ backgroundColor: 'grey', color: '#ffffff',marginRight: '5px'}}/>
                </div>
            ) : (
                (rowData?.manager || rowData?.template?.manager) && (
                <div className='mr-2'>
                    <Avatar
                    title={rowData?.manager?.employee?.name || rowData?.manager?.username || rowData?.template?.manager?.employee?.name || rowData?.template?.manager?.username}
                    label={getUserInitials(rowData?.manager?.employee?.name || rowData?.manager?.username || rowData?.template?.manager?.employee?.name || rowData?.template?.manager?.username)}
                    shape="circle"
                    style={{
                        backgroundColor: getUserColor(rowData?.manager?.username || rowData?.template?.manager?.username),
                        color: "#ffffff",
                        marginRight: "5px",
                    }}
                    />
                </div>
                )
            )}

            {timeToShow && (
                <div>
                {/* ak máš SQL string */}
                {formatDate(timeToShow, true)}
                </div>
            )}
            </div>
        );
    }

    function managerHeaderFilter(headerValue, rowValue, rowData) {
        if (!headerValue) return true;
        const search = removeDiacritics(headerValue).toLowerCase();
        if(rowData?.status === "NOK" && (rowData?.checklist_status || "").toLowerCase() !== "uzavretý")return false;

        const isBotCase =
            rowData?.status === "OK" &&
            (rowData?.checklist_status || "").toLowerCase() === "uzavretý";

        const who = isBotCase
            ? "System"
            : (rowData?.manager?.employee?.name ||
            rowData?.manager?.username ||
            rowData?.template?.manager?.employee?.name ||
            rowData?.template?.manager?.username ||
            "");
        const timeToShow = isBotCase ? rowData?.user_update_at : rowData?.manager_update_at;

        let formattedDate = "";
        if (timeToShow) {
            const dtSql = DateTime.fromSQL(timeToShow);
            const dt = dtSql.isValid ? dtSql : DateTime.fromISO(timeToShow);
            formattedDate = dt.isValid ? dt.toFormat(dateTimeFmt) : "";
        }

        const combined = `${who} ${formattedDate}`;
        return removeDiacritics(combined).toLowerCase().includes(search);
    }

    function IDRowFormatter(props) {
        const rowData = props.cell.getRow().getData();
        if(rowData?.id)return formatID("CHL-",3,rowData?.id);
        return t('Status.NotCreated');
    } 
        
    function IDRowFilter(headerValue, rowValue, rowData) {
        if (!headerValue) return true;
        const search = removeDiacritics(String(headerValue).toLowerCase());
        const displayed = rowData?.id
            ? formatID("CHL-", 3, rowData.id)
            : t('Status.NotCreated');
        return removeDiacritics(displayed.toLowerCase()).includes(search);
    }
    
        const EMPTY_OPTION = { label: t('Common.EmptyParen'), value: "__empty__" };
        const processStatusOptions = [
          EMPTY_OPTION,
          { label: t('Status.Created'), value: "Vytvorený" },
          { label: t('Status.InProgressWork'), value: "Rozpracovaný" },
          { label: t('Status.NotCreated'), value: "Nevytvorený" },
        ];
        const managerStatusOptions = [
          EMPTY_OPTION,
          { label: t('Common.New'), value: "Nový" },
          { label: t('Common.Yes'), value: "Áno" },
          { label: t('Common.No'), value: "Nie" },
        ];
        const departmentOptions = useMemo(() => [
          { label: t('Common.EmptyParen'), value: "__empty__" },
          ...(state.departments || [])
            .filter(d => d?.id != null && d?.id !== "")
            .map(d => ({ label: d.name, value: String(d.id) }))
            .sort((a, b) => (a.label || "").localeCompare(b.label || "", "sk")),
        ], [state.departments]);
        const userOptions = useMemo(() => [
          EMPTY_OPTION,
          ...(state.users || [])
            .filter(u => u?.id != null)
            .map(u => ({ label: u?.employee?.name || u?.username || String(u.id), value: String(u.id) }))
            .sort((a, b) => (a.label || "").localeCompare(b.label || "", "sk")),
        ], [state.users]);
        const managerOptions = useMemo(() => [
          EMPTY_OPTION,
          ...(state.users || [])
            .filter(u => u?.id != null)
            .map(u => ({ label: u?.employee?.name || u?.username || String(u.id), value: String(u.id) }))
            .sort((a, b) => (a.label || "").localeCompare(b.label || "", "sk")),
        ], [state.users]);

        const norm = (v) => removeDiacritics(String(v ?? "")).toLowerCase().trim();
        
        function getManagerDeadlineInfo(rowData) {
            const baseDate = parseDT(rowData?.user_update_at) || parseDT(rowData?.created_at);
            const dueDays = Number(rowData?.template?.manager_due_days ?? 0);
            if (!baseDate) return { deadline: null, isRed: false };
    
const deadline = baseDate.plus({ days: dueDays }).endOf("day");
            const now = DateTime.now().setZone(timezone);

            const expressedAt = parseDT(rowData?.manager_update_at);
    
            const isLateExpression = !!(expressedAt && expressedAt > deadline);
            const isExpiredAndNotExpressed = !expressedAt && now > deadline;
    
            const isRed = (isLateExpression || isExpiredAndNotExpressed) && rowData?.status !== "OK";
            return { deadline, isRed };
        }
    
        const parseDT = (value) => {
            if (!value) return null;
            let dt = DateTime.fromISO(value);
            if (dt.isValid) return dt;
            dt = DateTime.fromSQL(value);
            if (dt.isValid) return dt;
            return null;
        };
    
        function DeadlineFormatter(props) {
            const rowData = props.cell.getRow().getData();
            const baseDate = parseDT(rowData?.user_update_at) || parseDT(rowData?.created_at);
            if (!baseDate) return <div className="flex items-center justify-start w-full h-full"></div>;
            const { deadline, isRed } = getManagerDeadlineInfo(rowData);
            const managerName =
            rowData?.manager?.employee?.name ||
            rowData?.manager?.username ||
            rowData?.template?.manager?.employee?.name ||
            rowData?.template?.manager?.username ||
            "";
            const managerUsername =
            rowData?.manager?.username ||
            rowData?.template?.manager?.username ||
            "";
    
            return (
            <div className="flex items-center justify-start w-full h-full">
                {(rowData?.manager || rowData?.template?.manager) && (
                <div className="mr-2">
                    <Avatar
                    title={managerName}
                    label={getUserInitials(managerName)}
                    shape="circle"
                    style={{
                        backgroundColor: getUserColor(managerUsername),
                        color: "#ffffff",
                        marginRight: "5px",
                    }}
                    />
                </div>
                )}
                <div className={isRed ? "text-red-600 font-semibold" : ""}>
                {deadline.toFormat(dateFmt)}
                </div>
            </div>
            );
        }
    
        function deadlineFilter(headerValue, rowValue, rowData) {
            const q = norm(headerValue);
            if (!q) return true;
    
            const { deadline, isRed } = getManagerDeadlineInfo(rowData);
            if (!deadline) return false;
    
            if (q === "nok" || q === "!" || q.includes("cerv") || q.includes("red") || q.includes("po termine") || q.includes("omesk") || q.includes("overdue") || q.includes("late")) {
            return isRed;
            }
            if (q === "ok" || q.includes("zel") || q.includes("green") || q.includes("v poriadku") || q.includes("bez cerv")) {
            return !isRed;
            }
    
            const formattedDeadline = deadline.toFormat(dateFmt);
            const isoDeadline = deadline.toFormat("yyyy-MM-dd");
            const shortDeadline = deadline.toFormat("dd.MM.");
    
            const managerName =
            rowData?.manager?.employee?.name ||
            rowData?.manager?.username ||
            rowData?.template?.manager?.employee?.name ||
            rowData?.template?.manager?.username ||
            "";
    
            const combined = `${formattedDeadline} ${isoDeadline} ${shortDeadline} ${managerName}`;
            return norm(combined).includes(q);
        }
    
        const [columns, setColumns] = useState([
          { formatter:"rowSelection", titleFormatter:"rowSelection", hozAlign:"center", width: 44, headerSort: false, resizable: false },
          { hozAlign:"center", width: 44, headerSort: false, formatter: reactFormatter(<EditRowFormatter/>), resizable: false },
          { title: 'ID', field: 'id', formatter: reactFormatter(<IDRowFormatter/>), headerFilter:"input", headerFilterFunc: IDRowFilter, minWidth: 100, widthGrow:1},
          { title: t('Common.Description'), field: "name", headerFilter: "input", headerFilterFunc: genericFilter, minWidth: 190},
          { title: t('Common.Department'), field: "custom_department", minWidth: 220, formatter: reactFormatter(<DepartmentFormatter />),
            headerFilter: primeMultiSelectHeaderFilter,
            headerFilterParams: { placeholder: t('Common.FilterAll'), valueType: "string", options: departmentOptions },
            headerFilterFunc: (headerValue, rowValue, rowData) => {
              if (!headerValue) return true;
              const selected = new Set(String(headerValue).split(",").map(x => x.trim()).filter(Boolean));
              const deptId = rowData?.user?.employee?.department_id ?? rowData?.user?.employee?.department?.id;
              const isEmpty = deptId == null || deptId === "";
              if (selected.has("__empty__") && isEmpty) return true;
              if (!deptId) return false;
              return selected.has(String(deptId));
            }
          },
          { title: "Zamestnanci", field: "created_at", minWidth: 220, formatter: reactFormatter(<UserFormatter />),
            headerFilter: primeMultiSelectHeaderFilter,
            headerFilterParams: { placeholder: t('Common.FilterAll'), valueType: "string", options: userOptions },
            headerFilterFunc: (headerValue, rowValue, rowData) => {
              if (!headerValue) return true;
              const selected = new Set(String(headerValue).split(",").map(x => x.trim()).filter(Boolean));
              const userId = rowData?.user_id ?? rowData?.user?.id;
              const isEmpty = userId == null || userId === "";
              if (selected.has("__empty__") && isEmpty) return true;
              return selected.has(String(userId));
            }
          },
          { title: t('Checklist.Column.CompletionDate'),field: "user_update_at",minWidth: 230,formatter: reactFormatter(<UserUpdateFormatter />),headerFilter: "input",headerFilterFunc: userUpdateFilter,},
          { title: t('Checklist.Column.CompletionDeadline'),field: "execution_deadline",minWidth: 230,formatter: reactFormatter(<ExecutionDeadlineFormatter timezone={timezone} />),headerFilter: "input",headerFilterFunc: executionDeadlineFilter,headerFilterFuncParams: { getDateFormat: () => getDateFormat?.() ?? "dd.MM.yyyy", timezone },},
          { title: t('Common.Status'), field: "status", minWidth: 180,
            headerFilter: primeMultiSelectHeaderFilter,
            headerFilterParams: { placeholder: t('Common.FilterAll'), valueType: "string", options: [EMPTY_OPTION, { label: "OK", value: "OK" }, { label: "NOK", value: "NOK" }] },
            headerFilterFunc: (headerValue, rowValue) => {
              if (!headerValue) return true;
              const selected = new Set(String(headerValue).split(",").map(x => x.trim()).filter(Boolean));
              const isEmpty = rowValue == null || String(rowValue).trim() === "";
              if (selected.has("__empty__") && isEmpty) return true;
              return selected.has(String(rowValue));
            }
          },
          { title: t('Checklist.Column.ProcessStatus'), field: "process_status", minWidth: 200,
            headerFilter: primeMultiSelectHeaderFilter,
            headerFilterParams: { placeholder: t('Common.FilterAll'), valueType: "string", options: processStatusOptions },
            headerFilterFunc: (headerValue, rowValue) => {
              if (!headerValue) return true;
              const selected = new Set(String(headerValue).split(",").map(x => x.trim()).filter(Boolean));
              const isEmpty = rowValue == null || String(rowValue).trim() === "";
              if (selected.has("__empty__") && isEmpty) return true;
              return selected.has(String(rowValue));
            }
          },
          { title: t('Checklist.ResponsibleManager'), field: "manager_name", minWidth: 220, formatter: reactFormatter(<ManagerFormatter />),
            headerFilter: primeMultiSelectHeaderFilter,
            headerFilterParams: { placeholder: t('Common.FilterAll'), valueType: "string", options: managerOptions },
            headerFilterFunc: (headerValue, rowValue, rowData) => {
              if (!headerValue) return true;
              const selected = new Set(String(headerValue).split(",").map(x => x.trim()).filter(Boolean));
              const managerId = rowData?.template?.manager_id ?? rowData?.template?.manager?.id ?? rowData?.manager_id ?? rowData?.manager?.id;
              const isEmpty = managerId == null || managerId === "";
              if (selected.has("__empty__") && isEmpty) return true;
              return selected.has(String(managerId));
            }
          },
          { title: "Deadline vyjadrenia", field: "deadline", minWidth: 210, formatter: reactFormatter(<DeadlineFormatter />),headerFilter: "input",headerFilterFunc: deadlineFilter,},
          { title: "Vyjadrenie", field: "manager_response", headerFilter: "input", headerFilterFunc: genericFilter, minWidth: 200, widthGrow:1},
          { title: t('Checklist.Column.ResponseStatus'), field: "manager_status", minWidth: 200, widthGrow: 1,
            headerFilter: primeMultiSelectHeaderFilter,
            headerFilterParams: { placeholder: t('Common.FilterAll'), valueType: "string", options: managerStatusOptions },
            headerFilterFunc: (headerValue, rowValue) => {
              if (!headerValue) return true;
              const selected = new Set(String(headerValue).split(",").map(x => x.trim()).filter(Boolean));
              const isEmpty = rowValue == null || String(rowValue).trim() === "";
              if (selected.has("__empty__") && isEmpty) return true;
              return selected.has(String(rowValue));
            }
          },
          { title: t('Checklist.Column.ChecklistStatus'), field: "checklist_status", minWidth: 200,
            headerFilter: primeMultiSelectHeaderFilter,
            headerFilterParams: { placeholder: t('Common.FilterAll'), valueType: "string", options: [EMPTY_OPTION, { label: t('Status.Open'), value: "Otvorený" }, { label: t('Status.Closed'), value: "Uzavretý" }] },
            headerFilterFunc: (headerValue, rowValue) => {
              if (!headerValue) return true;
              const parts = String(headerValue).split(",").map(x => x.trim()).filter(Boolean);
              const isEmpty = rowValue == null || String(rowValue).trim() === "";
              if (parts.includes("__empty__") && isEmpty) return true;
              const rowNorm = (rowValue ?? "").toString().trim();
              return parts.some(p => p === rowNorm);
            }
          },
        ]);

    function setMask(item,value){
        const columnVisible = {...columnsVisible};
       columnVisible[item] = value;
        for(const val in columnVisible) {
          if(columnVisible[val]==false){
            ref.current.hideColumn(`${val}`);
          }
          else{
            ref.current.showColumn(`${val}`);
          }
        }
        setColumnsVisible(columnVisible);
      }

    const resetMask = () => resetTabulatorMask({
      page: 'ChecklistRecordAdd',
      defaultColumnsVisible: DEFAULT_COLUMNS_VISIBLE_ADD,
      ref,
      columns,
      setColumnsVisible,
    });

    const normalizeMaskValue = (field, value) => {
      if (value === null || value === undefined) return "";
      if (field === "is_unread") return value === "" ? "" : String(value);
      return value;
    };

    const mergeAttributesWithCurrentOptions = (attrs) => {
      if (!Array.isArray(attrs)) return attrs;
      return attrs.map(a => {
        if (typeof a !== "object" || a == null) return a;
        const copy = { ...a };
        const field = copy.field;
        if (field === "custom_department" && Array.isArray(departmentOptions) && departmentOptions.length > 0) {
          copy.headerFilterParams = { ...(copy.headerFilterParams || {}), options: departmentOptions, valueType: "string", placeholder: t('Common.FilterAll') };
        } else if (field === "created_at" && Array.isArray(userOptions) && userOptions.length > 0) {
          copy.headerFilterParams = { ...(copy.headerFilterParams || {}), options: userOptions, valueType: "string", placeholder: t('Common.FilterAll') };
        } else if (field === "manager_name" && Array.isArray(managerOptions) && managerOptions.length > 0) {
          copy.headerFilterParams = { ...(copy.headerFilterParams || {}), options: managerOptions, valueType: "string", placeholder: t('Common.FilterAll') };
        } else if (field === "status") {
          copy.headerFilterParams = { ...(copy.headerFilterParams || {}), options: [EMPTY_OPTION, { label: "OK", value: "OK" }, { label: "NOK", value: "NOK" }], valueType: "string", placeholder: t('Common.FilterAll') };
        } else if (field === "process_status" && Array.isArray(processStatusOptions) && processStatusOptions.length > 0) {
          copy.headerFilterParams = { ...(copy.headerFilterParams || {}), options: processStatusOptions, valueType: "string", placeholder: t('Common.FilterAll') };
        } else if (field === "manager_status" && Array.isArray(managerStatusOptions) && managerStatusOptions.length > 0) {
          copy.headerFilterParams = { ...(copy.headerFilterParams || {}), options: managerStatusOptions, valueType: "string", placeholder: t('Common.FilterAll') };
        } else if (field === "checklist_status") {
          copy.headerFilterParams = { ...(copy.headerFilterParams || {}), options: [EMPTY_OPTION, { label: t('Status.Open'), value: "Otvorený" }, { label: t('Status.Closed'), value: "Uzavretý" }], valueType: "string", placeholder: t('Common.FilterAll') };
        }
        return copy;
      });
    };

      const itemRenderer = (item, options) => (
        <a className="flex align-items-center px-3 py-2 cursor-pointer items-center bg-[#333] text-white w-[180px]" onClick={options.onClick}>
            <span className={`${item.icon} text-primary`} />
            <span className={`mx-2 ${item.items && 'font-semibold'}`}>{item.label}</span>
            {item.shortcut && <span className="ml-auto border-1 surface-border border-round surface-100 text-xs p-1">{item.shortcut}</span>}
        </a>
      );
    
      const [expandedKeys, setExpandedKeys] = useState({});
    
      const handleClickOutside = (event) => {
        if (overlayRef.current && !overlayRef.current.contains(event.target)) {
            setExpandedKeys({});
        }
      };
    
      useEffect(() => {
        document.addEventListener('click', handleClickOutside, true);
        return () => {
            document.removeEventListener('click', handleClickOutside, true);
        };
    }, []);
  
      const items = [
      {
        key: '0',
        label: t('Common.Actions'),
        icon: 'pi pi-sliders-v',
        template: itemRenderer,
        items: [
            {
                key: '0_1',
                label: t('Common.SetFilter'),
                icon: 'pi pi-filter',
                command: () => {setUserMaskFilter("ChecklistRecordAdd","set_filters",null,ref.current.getHeaderFilters(),null);},
                template: itemRenderer,
            },
              {
                key: '0_2',
                label: t('Common.ClearFilter'),
                icon: 'pi pi-filter-slash',
                command: () => {setUserMaskFilter("ChecklistRecordAdd","set_filters",null,[],null);ref.current.clearHeaderFilter();},
                template: itemRenderer,
            },
            {
                key: '0_3',
                label: t('ServiceTask.SetSort'),
                icon: 'pi pi-sort-alt',
                command: () => {setUserMaskFilter("ChecklistRecordAdd","set_sorters",null,null,null,ref.current.getSorters());OverflowMenuProvider.setVisible(null);setExpandedKeys({});},
                template: itemRenderer,
            },
            {
                key: '0_4',
                label: t('Common.ClearSorting'),
                icon: 'pi pi-sort-alt-slash',
                command: () => {setUserMaskFilter("ChecklistRecordAdd","set_sorters",null,null,null,[]);ref.current.setSort([]);OverflowMenuProvider.setVisible(null);setExpandedKeys({});},
                template: itemRenderer,
            },
            {
                key: '0_5',
                label: t('Common.SetMask'),
                icon: 'pi pi-server',
                command: () => {setMaskVisible(true);OverflowMenuProvider.setVisible(null);setExpandedKeys({});},
                template: itemRenderer,
            },
            {
              key: '0_5b',
              label: t('Common.ResetUserMask'),
              icon: 'pi pi-refresh',
              command: () => { resetMask(); OverflowMenuProvider.setVisible(null); setExpandedKeys({}); },
              template: itemRenderer,
            },
            {
              key: '0_6',
              label: t('Common.Notifications'),
              icon: 'pi pi-envelope',
              command: () => {openChosenNotificationPreferences('ChecklistRecordAdd');OverflowMenuProvider.setVisible(null);},
              template: itemRenderer,
          },
        ]
      }
    ];function changeMarkings(value){
        if(value){
          const columnVisible = {...columnsVisible};
          for(let val in columnVisible) {
            if(columnVisible[val]!=="id" || columnVisible[val]!=="editor"){
              columnVisible[val]=true;
              ref.current.showColumn(`${val}`);
            }
          };
          setColumnsVisible(columnVisible);
        }
        else{
          const columnVisible = {...columnsVisible};
          for(let val in columnVisible) {
            if(columnVisible[val]!=="id" || columnVisible[val]!=="editor"){
              columnVisible[val]=false;
              ref.current.hideColumn(`${val}`);
            }
          };
          setColumnsVisible(columnVisible);
        }
    }

    const accept = () => {
        const rows_to_delete = ref.current.getSelectedData();
        setDialogText(t('Common.Deleting'));
        setVisible(true);

        const deletePromises = rows_to_delete.map((element) =>
            deleteRequest(`/api/checklist_records/${element.id}`)
        );

        Promise.allSettled(deletePromises).then((results) => {
            setVisible(false);
            const successCount = results.filter(r => r.status === "fulfilled").length;
            const failCount = results.filter(r => r.status === "rejected").length;

            if (successCount > 0 && failCount === 0) {
                toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), detail: t('Common.Toast.RecordsDeletedDetail').replace('{{count}}', String(successCount)), life: 3000 });
            } else if (successCount > 0 && failCount > 0) {
                toast?.current?.show({ severity: 'warn', summary: t('Common.Toast.PartialDeletedSummary'), detail: t('Common.Toast.PartialDeletedDetail').replace('{{success}}', String(successCount)).replace('{{fail}}', String(failCount)), life: 3000 });
            } else {
                toast?.current?.show({ severity: 'error', summary: t('Common.Error'), detail: t('Common.Toast.NoneDeletedDetail'), life: 3000 });
            }

            refreshFromStart();
        });
    };

    const reject = () => {
        toast?.current?.show({ severity: 'warn', summary: t('Common.Rejected'), detail: t('Common.RequestCancelled'), life: 3000 });
    }

    const confirm = () => {
        confirmDialog({
            message: t('ServiceTask.ConfirmDeleteRecord'),
            header: t('Common.ConfirmDelete'),
            icon: 'pi pi-info-circle',
            acceptClassName: 'p-button-danger',
            acceptLabel: t('Common.Yes'),
            rejectLabel: t('Common.No'),
            accept,
            reject
        });
    };

    useEffect(() => {
        const channel = getPusherChannel();
        if (!channel) return;
        const isMine = (record) => (record?.user_id ?? record?.user?.id) == user?.id;
        const getId = (data) => data?.id ?? data?.record?.id ?? null;
        const DEDUPE_MS = 800;
        const lastHandled = { key: '', at: 0 };
        const shouldSkip = (eventType, id) => {
            if (id == null) return true;
            const key = `${eventType}-${id}`;
            const now = Date.now();
            if (lastHandled.key === key && now - lastHandled.at < DEDUPE_MS) return true;
            lastHandled.key = key;
            lastHandled.at = now;
            return false;
        };

        const captureScroll = () => {
            const t = ref.current;
            if (!t?.rowManager?.element) return null;
            const holder = t.rowManager.element;
            const header = t.columnManager?.contentsElement;
            return { v: holder.scrollTop, h: header ? header.scrollLeft : holder.scrollLeft || 0 };
        };
        const restoreScroll = (pos) => {
            if (!pos) return;
            requestAnimationFrame(() => {
                const t = ref.current;
                if (!t?.rowManager?.element) return;
                const holder = t.rowManager.element;
                const header = t.columnManager?.contentsElement;
                holder.scrollTop = pos.v;
                if (header) header.scrollLeft = pos.h;
            });
        };

        const onUpdated = (data) => {
            const id = getId(data);
            if (!id || shouldSkip('updated', id) || !ref.current?.updateOrAddData) return;
            const scroll = captureScroll();
            getRequest(`/api/checklist_records/${id}`)
                .then((res) => {
                    const record = res?.data ?? res;
                    if (!record?.id) return;
                    if (record?.validity === 0) {
                        const row = ref.current?.getRows?.().find((r) => r.getData().id === record.id);
                        if (row) row.delete();
                    } else if (isMine(record)) {
                        ref.current.updateOrAddData([record]);
                        if (typeof ref.current.getFilters === 'function' && typeof ref.current.setFilter === 'function') {
                            const filters = ref.current.getFilters();
                            if (Array.isArray(filters) && filters.length) ref.current.setFilter(filters);
                        }
                    }
                    restoreScroll(scroll);
                })
                .catch(() => {});
        };
        const onCreated = (data) => {
            const id = getId(data);
            if (!id || shouldSkip('created', id) || !ref.current?.addData) return;
            getRequest(`/api/checklist_records/${id}`)
                .then((res) => {
                    const record = res?.data ?? res;
                    if (!record?.id || record?.validity === 0) return;
                    if (isMine(record)) ref.current.addData([record], true);
                })
                .catch(() => {});
        };
        const onDeleted = (data) => {
            const id = getId(data);
            if (id == null || shouldSkip('deleted', id)) return;
            const row = ref.current?.getRows?.().find((r) => r.getData().id === id);
            if (row) row.delete();
        };
        channel.bind('checklist_record.created', onCreated);
        channel.bind('checklist_record.updated', onUpdated);
        channel.bind('checklist_record.deleted', onDeleted);
        return () => {
            channel.unbind('checklist_record.created', onCreated);
            channel.unbind('checklist_record.updated', onUpdated);
            channel.unbind('checklist_record.deleted', onDeleted);
        };
    }, [user?.id]);

    const acceptFile = (id) => {
        setDialogText(t('Common.Deleting'));
        setVisible(true);
        getRequest(`/api/checklist_records/deleteProtocol/${id}`)
        .then((response) => {
            setVisible(false);
            toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('Common.Toast.FileDeletedDetail') });
            getRecordFiles(selectedRecord?.id);
        }).catch((reason) => {
            setVisible(false);
            alert(reason);
            toast?.current?.show({ severity: 'warn', summary: t('Common.Rejected'), detail: t('Common.Toast.FileDeleteFailedDetail'), life: 3000 });
        })
    };

    function deleteFiles(img){
        confirmDialog({
            message: t('ServiceTask.DeleteFilePrompt'),
            header: t('Common.ConfirmDelete'),
            icon: 'pi pi-info-circle',
            acceptClassName: 'p-button-danger',
            acceptLabel: t('Common.No'),
            rejectLabel: t('Common.Yes'),
            accept:reject,
            reject:() => acceptFile(img.id)
        });
    }

    return ( 
        <>
            <div>
            <div className='w-full h-10 flex flex-row bg-[#333]'> 
            <IntersectionObserverWrapper>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="add"><button className="disabled:opacity-25" disabled={!canCreate} onClick={() => addChecklistRecord()}><AddIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="copy"><button className="disabled:opacity-25" disabled={copyIcon} onClick={() => copyChecklistRecord()}><CopyIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="edit"><button className="disabled:opacity-25" disabled={editIcon} onClick={() => editChecklistRecord()}><EditIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="delete"><button className="disabled:opacity-25" disabled={deleteIcon} onClick={confirm}><DeleteIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="refresh"><button onClick={() => refreshFromStart()} title={t('Common.Refresh')}><RefreshIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="vert"><VerticalLineIcon/></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="first"><button className="disabled:opacity-25" onClick={() => scrollToFirst()} disabled={scrollIcons}><BackToFirstIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="back"><button className="disabled:opacity-25" onClick={() => scrollUp()} disabled={scrollIcons}><BackIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="forward"><button className="disabled:opacity-25" onClick={() => scrollDown()} disabled={scrollIcons}><ForwardIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="last"><button className="disabled:opacity-25" onClick={() => scrollToLast()} disabled={scrollIcons}><ForwardToLastIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="vert"><VerticalLineIcon/></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="favorite"><button className="disabled:opacity-25" disabled onClick={() => openFavoriteDialog(t('Checklist.EditRecord'),"ChecklistRecordAdd")}><FavoriteIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="price"><button className="disabled:opacity-25" disabled onClick={() => setFastView("ChecklistRecordAdd",columnsVisible,columns)}><PriceIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="vert"><VerticalLineIcon/></div>
          <div className="card flex justify-content-center z-[100]" data-targetid="actions" ref={overlayRef}>
            <PanelMenu model={items} expandedKeys={expandedKeys} onExpandedKeysChange={setExpandedKeys} className="w-full md:w-20rem"/>
          </div>
          </IntersectionObserverWrapper>
        </div>
        <Splitter className='h-[calc(100vh_-_177px)]' layout="vertical" pt={{ gutter: { className: 'bg-[#333] h-8' },gutterHandler: { className: 'bg-secondary ' } }}>
        <SplitterPanel className="overflow-y-auto" minSize={20} size={45}>
            <div className="w-full p-4">
                <h2 className="text-2xl font-bold mb-3 text-zinc-800">Checklist</h2>

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-6">
                    {/* 1. stĺpec */}
                    <div className="space-y-3">
                    {/* Názov */}
                    <div>
                        <label className="block text-md font-semibold text-gray-800">{t('Common.Name')}</label>
                        <input
                        name="name"
                        value={checklist_template?.name ?? ''}
                        disabled
                        className="block w-full px-4 py-2 mt-1 border rounded-md bg-gray-100 text-gray-700"
                        />
                    </div>

                    {/* Oddelenie */}
                    <div>
                        <label className="block text-md font-semibold text-gray-800">{t('Common.Department')}</label>
                        <div className="block w-full px-4 py-2 mt-1 border rounded-md bg-gray-100 text-gray-700">
                        {(state?.departments || [])
                            .map(department =>
                            checklist_template?.users?.find(user => user?.employee?.department_id === department?.id)?.employee?.department?.name
                            )
                            .filter(Boolean)
                            .filter((v, i, a) => a.indexOf(v) === i)
                            .join(', ') || '–'}
                        </div>
                    </div>

                    {/* Zamestnanec */}
                    <div>
                        <label className="block text-md font-semibold text-gray-800">Zamestnanec</label>
                        <div className="block w-full px-4 py-2 mt-1 border rounded-md bg-gray-100 text-gray-700">
                        {(checklist_template?.users || [])
                            .map(user => user?.employee?.name || user?.username)
                            .filter(Boolean)
                            .join(', ') || '–'}
                        </div>
                    </div>
                    </div>

                    {/* 2. stĺpec */}
                    <div className="space-y-3">
                    {/* Intenzita */}
                    <div>
                        <label className="block text-md font-semibold text-gray-800">Intenzita</label>
                        <div className="block w-full px-4 py-2 mt-1 border rounded-md bg-gray-100 text-gray-700">
                        {(() => {
                            const value = checklist_template?.sending_data;
                            if (!value) return "–";
                            let data;
                            try {
                            data = JSON.parse(value);
                            } catch {
                            return "–";
                            }

                            const intensity = data.intensity || "";
                            const time = data.time || "";
                            const specialDaysMap = {
                            "first_monday": t('ChecklistTemplate.SpecialDay.first_monday'), "first_tuesday": t('ChecklistTemplate.SpecialDay.first_tuesday'), "first_wednesday": t('ChecklistTemplate.SpecialDay.first_wednesday'),
                            "first_thursday": t('ChecklistTemplate.SpecialDay.first_thursday'), "first_friday": t('ChecklistTemplate.SpecialDay.first_friday'), "last_monday": t('ChecklistTemplate.SpecialDay.last_monday'),
                            "last_tuesday": t('ChecklistTemplate.SpecialDay.last_tuesday'), "last_wednesday": t('ChecklistTemplate.SpecialDay.last_wednesday'), "last_thursday": t('ChecklistTemplate.SpecialDay.last_thursday'),
                            "last_friday": t('ChecklistTemplate.SpecialDay.last_friday')
                            };

                            switch (intensity) {
                            case "denne": return t('Checklist.Intensity.DailyTpl', { time });
                            case "tyzdenne": return t('Checklist.Intensity.WeeklyTpl', { days: (data.daysOfWeek || []).join(', '), time });
                            case "mesacne": {
                                if (data.dayMonth) return t('Checklist.Intensity.MonthlySpecialTpl', { day: specialDaysMap[data.dayMonth] || data.dayMonth, time });
                                if (data.daysOfMonth) return t('Checklist.Intensity.MonthlyDayTpl', { day: data.daysOfMonth, time });
                                return t('Checklist.Intensity.MonthlyTimeTpl', { time });
                            }
                            case "rocne": return t('Checklist.Intensity.YearlyTpl', { day: data.day || '', month: data.month || '', time });
                            case "viackrat_den": return t('Checklist.Intensity.MultiDailyTpl', { times: (data.times || []).join(', ') });
                            case "nahodne": return t('Checklist.Intensity.Random');
                            default: return intensity || "–";
                            }
                        })()}
                        </div>
                    </div>

                    {/* Vedúci */}
                    <div>
                        <label className="block text-md font-semibold text-gray-800">{t('Checklist.ResponsibleManager')}</label>
                        <div className="block w-full px-4 py-2 mt-1 border rounded-md bg-gray-100 text-gray-700">
                        {(state?.users || [])
                            .filter(user => user?.id == checklist_template?.manager_id)
                            .map(user => user?.employee?.name || user?.username)
                            .join(', ') || '–'}
                        </div>
                    </div>

                    {/* Dni na vyjadrenie */}
                    <div>
                        <label className="block text-md font-semibold text-gray-800">Dni na vyjadrenie</label>
                        <div className="block w-full px-4 py-2 mt-1 border rounded-md bg-gray-100 text-gray-700">
                        {checklist_template?.manager_due_days || '–'}
                        </div>
                    </div>
                    </div>

                    {/* 3. stĺpec – Popis */}
                    <div className="space-y-3">
                    <div>
                    <label className="block text-md font-semibold text-gray-800">Stroj</label>
                        <div className="block w-full px-4 py-2 mt-1 border rounded-md bg-gray-100 text-gray-700">
                        {checklist_template?.machine?.name || '–'}
                        </div>
                    </div>
                    <div>
                        <label className="block text-md font-semibold text-gray-800">{t('Common.Description')}</label>
                        <textarea
                            disabled
                            value={checklist_template?.description || '–'}
                            rows={4}
                            className="block w-full px-4 py-2 mt-1 border rounded-md bg-gray-100 text-gray-700 resize-none"
                        />
                    </div>
                    </div>
                </div>
                </div>
        </SplitterPanel>
        <SplitterPanel className="overflow-y-auto" size={55} style={{ minHeight: '110px' }}>
            <ReactTabulator
            columns={columns}
            className='h-[calc(100vh_-_520px)]'
            onRef={(r) => (ref.current = r.current)}
            options={{
                layout: "fitColumns",
                rowHeight: 42,
                renderHorizontal: "virtual",
                movableColumns: true,
                printAsHtml: true,
                printHeader: () => buildCanonicalPrintHeaderHtml({
                  branding: state?.branding,
                  productFallbackSrc: defaultProductLogoSrc,
                  companySettingsPrint: state?.company_settings_print,
                  moduleSettings: state?.module_settings,
                  title: t('Print.Title.ChecklistRecordAdd'),
                  printDateLabel: t('Print.DateLabel'),
                }),
                printFooter: () => buildCanonicalPrintFooterHtml({ companySettingsPrint: state?.company_settings_print }),
                printRowRange: "active",
                autoResize: true,
                scrollToColumnIfVisible: false,
                dataLoader: true,
                dataLoaderLoading: t('Common.LoadingData'),
                dataLoaderError: t('Common.LoadingFailed'),
                placeholder: t('Common.NoData'),
                progressiveLoad: "scroll",
                progressiveLoadScrollMargin: 80,
                progressiveLoadDelay: 200,
                paginationSize: 100,
                progressiveRender: true,
                progressiveRenderSize: 30,
                pagination: false,
                filterMode: "remote",
                sortMode: "remote",
                ajaxURL: "/api/checklist_records/paged",
                ajaxParams: () => ({}),
                ajaxRequestFunc: createDedupedAjaxRequest(buildRequestParams, tabulatorGet, inFlightRef, completedCacheRef),
                ajaxRequesting: () => {
                  captureHScroll();
                  const table = ref.current;
                  if (table?.initialized) table.alert?.(t('Common.LoadingData'));
                  return true;
                },
                ajaxResponse: (url, params, response) => {
                    ref.current?.clearAlert?.();
                    pagingRef.current.current = response?.current_page ?? params?.page ?? pagingRef.current.current;
                    pagingRef.current.last = response?.last_page ?? pagingRef.current.last;
                    return response;
                },
                ajaxError: () => {
                    ref.current?.clearAlert?.();
                },
            }}
            events={{
                rowSelectionChanged: onSelectRow,
                tableBuilt: () => {
                    tableBuiltRef.current = true;
                    const mask = state.user_mask_filters.filter(m => m.page === "ChecklistRecordAdd");
                    if (mask.length > 0) {
                        let attributes = safeParse(mask[0].attributes, []);
                        attributes = mergeAttributesWithCurrentOptions(attributes);
                        const filters = safeParse(mask[0].filters, []);
                        const sorters = parseSorters(mask[0].sorters);
                        const json_columns = safeParse(mask[0].columns, {});
                        if (Array.isArray(attributes) && attributes.length > 1) {
                            ref.current?.setColumnLayout?.(attributes);
                        }
                        if (Array.isArray(filters) && filters.length > 0) {
                            filters.forEach(f => {
                                if (!f?.field) return;
                                ref.current?.setHeaderFilterValue?.(f.field, normalizeMaskValue(f.field, f.value), true);
                            });
                        } else {
                            ref.current?.clearHeaderFilter?.();
                        }
                        if (sorters.length > 0) {
                            ref.current?.setSort?.(sorters);
                        }
                        if (json_columns && typeof json_columns === "object") {
                            setColumnsVisible(json_columns);
                            for (const column in json_columns) {
                                if (json_columns[column] === false) ref.current?.hideColumn?.(column);
                                else ref.current?.showColumn?.(column);
                            }
                        }
                    }
                },
                dataProcessed: () => {
                    useMaskDefaultsRef.current = false;
                },
                headerFilterChanged: () => {
                    userInteractedRef.current = true;
                },
                sortChanged: () => {
                    userInteractedRef.current = true;
                },
                dataSorted: () => {
                    userInteractedRef.current = true;
                },
                columnMoved: () => {
                    setUserMaskFilter("ChecklistRecordAdd", "column_move", null, null, ref.current?.getColumnLayout?.());
                },
                columnResized: () => {
                    setUserMaskFilter("ChecklistRecordAdd", "column_resized", null, null, ref.current?.getColumnLayout?.());
                },
                renderComplete: () => {
                    restoreHScroll();
                },
            }}
            />
        </SplitterPanel>
        </Splitter>
            </div>
            <Dialog header={t('Checklist.AddRecord')} visible={showRecordAdd} style={{ width: '50vw' }} onHide={() => {setShowRecordAdd(false);setSelectedRecord(null);setImages([]);}}>
            <form onSubmit={formik.handleSubmit}>
            {/* Popis */}
            <div className="mb-4">
                <label className="block text-md font-semibold text-gray-800">{t('Common.Description')}</label>
                <input
                    name="name"
                    value={formik.values.name}
                    onChange={formik.handleChange}
                    className="block w-full px-4 py-2 mt-1 border rounded-md bg-gray-50 text-gray-700"
                    placeholder={t('Checklist.IdAutoFill')}
                />
            </div>

            {/* Poznámka zo šablóny */}
            <div className="mb-3">
                <label className="block text-md font-semibold text-gray-800">{t('Common.Note')}</label>
                <InputTextarea
                    autoResize
                    readOnly
                    value={checklist_template?.description}
                    className="w-full px-3 py-2 text-sm bg-gray-200 border rounded-md"
                />
            </div>

            <Accordion className='mb-3'>
                <AccordionTab  header="Podrobnosti">
                    {/* Intenzita + Stroj */}
                    <div className="md:col-span-2 grid grid-cols-1 sm:grid-cols-2 gap-6">
                    <div>
                    <label className="block text-md font-semibold text-gray-800">Intenzita</label>
                    <div className="block w-full px-4 py-2 mt-1 border rounded-md bg-gray-100 text-gray-700">
                        {(() => {
                        const value = checklist_template?.sending_data;
                        if (!value) return "–";

                        let data;
                        try {
                            data = JSON.parse(value);
                        } catch {
                            return "–";
                        }

                        const intensity = data.intensity || "";
                        const time = data.time || "";

                        const specialDaysMap = {
                            "first_monday": t('ChecklistTemplate.SpecialDay.first_monday'),
                            "first_tuesday": t('ChecklistTemplate.SpecialDay.first_tuesday'),
                            "first_wednesday": t('ChecklistTemplate.SpecialDay.first_wednesday'),
                            "first_thursday": t('ChecklistTemplate.SpecialDay.first_thursday'),
                            "first_friday": t('ChecklistTemplate.SpecialDay.first_friday'),
                            "last_monday": t('ChecklistTemplate.SpecialDay.last_monday'),
                            "last_tuesday": t('ChecklistTemplate.SpecialDay.last_tuesday'),
                            "last_wednesday": t('ChecklistTemplate.SpecialDay.last_wednesday'),
                            "last_thursday": t('ChecklistTemplate.SpecialDay.last_thursday'),
                            "last_friday": t('ChecklistTemplate.SpecialDay.last_friday'),
                        };

                        switch (intensity) {
                            case "denne": return t('Checklist.Intensity.DailyTpl', { time });
                            case "tyzdenne": {
                            const days = data.daysOfWeek || [];
                            return t('Checklist.Intensity.WeeklyTpl', { days: Array.isArray(days) ? days.join(', ') : days, time });
                            }
                            case "mesacne": {
                            if (data.dayMonth) return t('Checklist.Intensity.MonthlySpecialTpl', { day: specialDaysMap[data.dayMonth] || data.dayMonth, time });
                            if (data.daysOfMonth) return t('Checklist.Intensity.MonthlyDayTpl', { day: data.daysOfMonth, time });
                            return t('Checklist.Intensity.MonthlyTimeTpl', { time });
                            }
                            case "rocne": return t('Checklist.Intensity.YearlyTpl', { day: data.day || '', month: data.month || '', time });
                            case "viackrat_den": return t('Checklist.Intensity.MultiDailyTpl', { times: Array.isArray(data.times) ? data.times.join(', ') : data.times });
                            case "nahodne": return t('Checklist.Intensity.Random');
                            default: return intensity || "–";
                        }
                        })()}
                    </div>
                    </div>
                    <div>
                        <label className="block text-md font-semibold text-gray-800">Stroj</label>
                        <div className="block w-full px-4 py-2 mt-1 border rounded-md bg-gray-100 text-gray-700">
                            {checklist_template?.machine?.name || '–'}
                        </div>
                    </div>
                    </div>

                    {/* Oddelenie + Zamestnanec */}
                    <div className="md:col-span-2 grid grid-cols-1 sm:grid-cols-2 gap-6">
                    {/* Oddelenie */}
                    <div>
                        <label className="block text-md font-semibold text-gray-800">{t('Common.Department')}</label>
                        <div className="block w-full px-4 py-2 mt-1 border rounded-md bg-gray-100 text-gray-700">
                        {(state?.departments || [])
                            .map(department =>
                            checklist_template?.users?.find(user => user?.employee?.department_id === department?.id)?.employee?.department?.name
                            )
                            .filter(Boolean)
                            .filter((v, i, a) => a.indexOf(v) === i)
                            .join(', ') || '–'}
                        </div>
                    </div>

                    {/* Zamestnanec */}
                    <div>
                        <label className="block text-md font-semibold text-gray-800">Zamestnanec</label>
                        <div className="block w-full px-4 py-2 mt-1 border rounded-md bg-gray-100 text-gray-700">
                        {(checklist_template?.users || [])
                            .map(user => user?.employee?.name || user?.username)
                            .filter(Boolean)
                            .join(', ') || '–'}
                        </div>
                    </div>
                    </div>
                    
                    <div className="md:col-span-2 grid grid-cols-1 sm:grid-cols-2 gap-6">
                        {/* Zodpovedný vedúci */}
                        <div>
                        <label className="block text-md font-semibold text-gray-800">{t('Checklist.ResponsibleManager')}</label>
                        <div className="block w-full px-4 py-2 mt-1 border rounded-md bg-gray-100 text-gray-700">
                            {(state?.users || [])
                            .filter(user => user?.id == checklist_template?.manager_id)
                            .map(user => user?.employee?.name || user?.username)
                            .join(', ') || '–'}
                        </div>
                        </div>

                        {/* Dni na vyjadrenie */}
                        <div>
                        <label className="block text-md font-semibold text-gray-800">Dni na vyjadrenie</label>
                        <div className="block w-full px-4 py-2 mt-1 border rounded-md bg-gray-100 text-gray-700">
                            {checklist_template?.manager_due_days || '–'}
                        </div>
                        </div>
                    </div>
                </AccordionTab>
            </Accordion>

            {/* Otázky */}
            <div className="space-y-6">
                {checklist_template?.questions?.map((q, idx) => {
                    const modes = typeof q.answer_modes === "string" 
                        ? JSON.parse(q.answer_modes || '{}') 
                        : (q.answer_modes || {});
                    const fieldName = `answers[${idx}]`;
                    const answer = formik.values.answers?.[idx] || {};

                    const relevantEmployees = Array.isArray(modes.priorityDepartments) && modes.priorityDepartments.length > 0
                        ? state?.employees?.filter(emp => emp?.date_of_departure==null || emp?.date_of_departure=="").filter(employee => modes.priorityDepartments.includes(employee?.department_id))
                        : state?.employees?.filter(emp => emp?.date_of_departure==null || emp?.date_of_departure=="");

                    return (
                        <div key={idx} className="border rounded-md bg-gray-50 p-4 shadow-sm">
                            {/* Otázka */}
                            <div className="flex items-start gap-3 mb-3">
                                <div className="flex-shrink-0 pt-2 text-md font-semibold text-gray-700">{idx + 1}.</div>
                                <InputTextarea
                                autoResize
                                readOnly
                                placeholder={t('Checklist.QuestionN', { n: idx + 1 })}
                                value={q.text}
                                className="w-full px-3 py-2 text-sm bg-gray-200 border rounded-md"
                                />
                            </div>

                            {/* OK/NOK/NO v jednom riadku */}
                            {(modes.okNok || modes.no) && (
                            <div className="flex gap-6 items-center mb-3">
                                {modes.okNok && (
                                    <>
                                    <div className="flex items-center gap-2">
                                        <RadioButton
                                        inputId={`ok-${idx}`}
                                        name={`answers.${idx}.okNokAnswer`}
                                        value="ok"
                                        checked={answer.okNokAnswer === 'ok'}
                                        className="custom-radio"
                                        onChange={(e) =>
                                            formik.setFieldValue(`answers.${idx}.okNokAnswer`, e.value)
                                        }
                                        />
                                        <label htmlFor={`ok-${idx}`} className="text-sm">OK</label>
                                    </div>

                                    <div className="flex items-center gap-2">
                                        <RadioButton
                                        inputId={`nok-${idx}`}
                                        name={`answers.${idx}.okNokAnswer`}
                                        value="nok"
                                        checked={answer.okNokAnswer === 'nok'}
                                        className="custom-radio"
                                        onChange={(e) =>
                                            formik.setFieldValue(`answers.${idx}.okNokAnswer`, e.value)
                                        }
                                        />
                                        <label htmlFor={`nok-${idx}`} className="text-sm">NOK</label>
                                    </div>
                                    </>
                                )}

                                {modes.no && (
                                    <div className="flex items-center gap-2">
                                    <RadioButton
                                        inputId={`no-${idx}`}
                                        name={`answers.${idx}.okNokAnswer`}
                                        value="no"
                                        checked={answer.okNokAnswer === 'no'}
                                        className="custom-radio"
                                        onChange={(e) => {
                                        formik.setFieldValue(`answers.${idx}.okNokAnswer`, e.value);
                                        formik.setFieldValue(`answers.${idx}.photos`, []); // Reset fotiek
                                        formik.setFieldValue(`answers.${idx}.employeeId`, ''); // Reset zamestnanca
                                        }}
                                    />
                                    <label htmlFor={`no-${idx}`} className="text-sm">NO</label>
                                    </div>
                                )}
                            </div>
                            )}
                            {formik.errors?.answers?.[idx]?.okNokAnswer && (<div className="text-red-500 text-sm mt-2">{formik.errors.answers[idx].okNokAnswer}</div>)}

                            {/* Poznámky k OK / NOK / NO */}
                            {Array.isArray(formik.values?.answers) && modes.okNote && formik.values.answers[idx]?.okNokAnswer === 'ok' && (
                                <div className="mb-3">
                                    <InputTextarea
                                    name={`answers.${idx}.okNote`}
                                    value={formik.values.answers[idx]?.okNote || ''}
                                    onChange={formik.handleChange}
                                    className="w-full text-sm border rounded-md"
                                    placeholder={t('Checklist.NoteOK')}
                                    />
                                    {formik.errors?.answers?.[idx]?.okNote && <div className="text-red-500 text-sm mt-1">{formik.errors?.answers?.[idx]?.okNote}</div>}
                                </div>
                            )}
                            {Array.isArray(formik.values?.answers) && modes.nokNote && formik.values.answers[idx]?.okNokAnswer === 'nok' && (
                                <div className="mb-3">
                                    <InputTextarea
                                    name={`answers.${idx}.nokNote`}
                                    value={formik.values.answers[idx]?.nokNote || ''}
                                    onChange={formik.handleChange}
                                    className="w-full mb-3 text-sm border rounded-md"
                                    placeholder={t('Checklist.NoteNOK')}
                                    />
                                    {formik.errors?.answers?.[idx]?.nokNote && <div className="text-red-500 text-sm mt-1">{formik.errors?.answers?.[idx]?.nokNote}</div>}
                                </div>
                            )}
                            {Array.isArray(formik.values?.answers) && modes.noNote && answer.okNokAnswer === 'no' && (
                            <div className="mb-3">
                                <InputTextarea
                                name={`answers.${idx}.noNote`}
                                value={formik.values.answers[idx]?.noNote || ''}
                                onChange={formik.handleChange}
                                className="w-full mb-3 text-sm border rounded-md"
                                placeholder={t('Checklist.NoteNO')}
                                required
                                />
                                {formik.errors?.answers?.[idx]?.noNote && (<div className="text-red-500 text-sm mt-1">{formik.errors?.answers?.[idx]?.noNote}</div>)}
                            </div>
                            )}

                            {/* Meno zamestnanca + Foto v jednom riadku */}
                            {Array.isArray(formik.values?.answers) && (modes.name || modes.photo || modes?.optional_photo) && (
                                <div className="flex flex-col sm:flex-row gap-4">
                                {(modes.name && answer.okNokAnswer != 'no') && (
                                    <div className="flex-1">
                                    <label className="block text-sm font-medium text-gray-700 mb-1">
                                        Vyber meno zamestnanca<span className="text-red-500">*</span>
                                    </label>
                                    <select
                                        name={`${fieldName}.employeeId`}
                                        value={answer.employeeId || ''}
                                        onChange={(e) => formik.setFieldValue(`${fieldName}.employeeId`, e.target.value)}
                                        className="w-full border rounded-md px-2 py-1 text-sm"
                                    >
                                        <option value="">-- Vyber zamestnanca --</option>
                                        {relevantEmployees.sort((a, b) => a.name.localeCompare(b.name, 'sk', { sensitivity: 'base' })).map(user => (
                                        <option key={user.id} value={user.id}>{user.name}</option>
                                        ))}
                                    </select>
                                    {formik.errors?.answers?.[idx]?.employeeId && <div className="text-red-500 text-sm mt-1">{formik.errors?.answers?.[idx]?.employeeId}</div>}
                                    </div>
                                )}
                                {((modes.photo && answer.okNokAnswer != 'no') || modes?.optional_photo) && (
                                <div className="flex-1">
                                    <label className="block text-sm font-medium text-gray-700 mb-1">
                                    Prilož fotografie{modes?.photo ? (<span className="text-red-500">*</span>): (<span className="text-gray-500">{t('Common.OptionalParen')}</span>)}
                                    </label>
                                    <input
                                    type="file"
                                    name={`${fieldName}.photos`}
                                    multiple
                                    accept="image/*"
                                    onChange={(e) =>
                                        formik.setFieldValue(`${fieldName}.photos`, e.currentTarget.files)
                                    }
                                    className="w-full text-sm"
                                    />
                                    {formik.errors?.answers?.[idx]?.photos && (
                                    <div className="text-red-500 text-sm mt-1">{formik.errors?.answers?.[idx]?.photos}</div>
                                    )}
                                </div>
                                )}
                                </div>
                            )}
                            </div>
                    );
                })}
            </div>

            <div className="flex gap-3 mt-6">
                <button
                    type="button"
                    onClick={() => {
                        formik.setFieldValue('save_mode', 'draft');
                        setPendingSubmit("insert");
                    }}
                    className="w-full h-10 font-medium px-2 py-1 tracking-wide text-gray-800 bg-yellow-200 border border-yellow-300 rounded-md hover:bg-yellow-300"
                >
                    Uložiť koncept
                </button>

                <button
                    type="button"
                    onClick={() => {
                        formik.setFieldValue('save_mode', 'save');
                        setPendingSubmit("insert");
                    }}
                    className="w-full h-10 font-medium px-2 py-1 tracking-wide text-white bg-zinc-900 rounded-md hover:bg-zinc-700"
                >
                    Uložiť
                </button>
            </div>
        </form>
        </Dialog>
        <Dialog header={t('Checklist.EditRecord')} visible={visibleRecord} style={{ width: '50vw' }} onHide={() => hideEditRecord()}>
        <form onSubmit={formikUpdate.handleSubmit}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span className='font-semibold'>ID: {formatID("CHL-",3,formikUpdate.values?.id)}</span>
            <span>
                Uložené{formikUpdate.values?.save_mode === "draft" ? " ako koncept" : ""}
            </span>
        </div>
        {/* Popis */}
            <div className="mt-1 mb-3">
                <label className="block text-md font-semibold text-gray-800">{t('Common.Description')}</label>
                <input
                    name="name"
                    value={formikUpdate.values.name}
                    onChange={formikUpdate.handleChange}
                    disabled={selectedRecord?.save_mode=="save"}
                    className="block w-full px-4 py-2 mt-1 border rounded-md bg-gray-100 text-gray-700"
                    placeholder={t('Checklist.IdAutoFill')}
                />
            </div>

            {/* Poznámka zo šablóny */}
            <div className="mb-3">
                <label className="block text-md font-semibold text-gray-800">{t('Common.Note')}</label>
                <InputTextarea
                    autoResize
                    readOnly
                    value={checklist_template?.description}
                    className="w-full px-3 py-2 text-sm bg-gray-200 border rounded-md"
                />
            </div>

            <Accordion className='mb-3'>
                <AccordionTab  header="Podrobnosti">
                    {/* Intenzita */}
                    <div className="md:col-span-2 grid grid-cols-1 sm:grid-cols-2 gap-6">
                    <div>
                    <label className="block text-md font-semibold text-gray-800">Intenzita</label>
                    <div className="block w-full px-4 py-2 mt-1 border rounded-md bg-gray-100 text-gray-700">
                        {(() => {
                        const value = checklist_template?.sending_data;
                        if (!value) return "–";

                        let data;
                        try {
                            data = JSON.parse(value);
                        } catch {
                            return "–";
                        }

                        const intensity = data.intensity || "";
                        const time = data.time || "";

                        const specialDaysMap = {
                            "first_monday": t('ChecklistTemplate.SpecialDay.first_monday'),
                            "first_tuesday": t('ChecklistTemplate.SpecialDay.first_tuesday'),
                            "first_wednesday": t('ChecklistTemplate.SpecialDay.first_wednesday'),
                            "first_thursday": t('ChecklistTemplate.SpecialDay.first_thursday'),
                            "first_friday": t('ChecklistTemplate.SpecialDay.first_friday'),
                            "last_monday": t('ChecklistTemplate.SpecialDay.last_monday'),
                            "last_tuesday": t('ChecklistTemplate.SpecialDay.last_tuesday'),
                            "last_wednesday": t('ChecklistTemplate.SpecialDay.last_wednesday'),
                            "last_thursday": t('ChecklistTemplate.SpecialDay.last_thursday'),
                            "last_friday": t('ChecklistTemplate.SpecialDay.last_friday'),
                        };

                        switch (intensity) {
                            case "denne": return t('Checklist.Intensity.DailyTpl', { time });
                            case "tyzdenne": {
                            const days = data.daysOfWeek || [];
                            return t('Checklist.Intensity.WeeklyTpl', { days: Array.isArray(days) ? days.join(', ') : days, time });
                            }
                            case "mesacne": {
                            if (data.dayMonth) return t('Checklist.Intensity.MonthlySpecialTpl', { day: specialDaysMap[data.dayMonth] || data.dayMonth, time });
                            if (data.daysOfMonth) return t('Checklist.Intensity.MonthlyDayTpl', { day: data.daysOfMonth, time });
                            return t('Checklist.Intensity.MonthlyTimeTpl', { time });
                            }
                            case "rocne": return t('Checklist.Intensity.YearlyTpl', { day: data.day || '', month: data.month || '', time });
                            case "viackrat_den": return t('Checklist.Intensity.MultiDailyTpl', { times: Array.isArray(data.times) ? data.times.join(', ') : data.times });
                            case "nahodne": return t('Checklist.Intensity.Random');
                            default: return intensity || "–";
                        }
                        })()}
                    </div>
                    </div>
                    <div>
                        <label className="block text-md font-semibold text-gray-800">Stroj</label>
                        <div className="block w-full px-4 py-2 mt-1 border rounded-md bg-gray-100 text-gray-700">
                            {checklist_template?.machine?.name || '–'}
                        </div>
                    </div>
                    </div>

                    {/* Oddelenie + Zamestnanec */}
                    <div className="md:col-span-2 grid grid-cols-1 sm:grid-cols-2 gap-6">
                    {/* Oddelenie */}
                    <div>
                        <label className="block text-md font-semibold text-gray-800">{t('Common.Department')}</label>
                        <div className="block w-full px-4 py-2 mt-1 border rounded-md bg-gray-100 text-gray-700">
                        {(state?.departments || [])
                            .map(department =>
                            checklist_template?.users?.find(user => user?.employee?.department_id === department?.id)?.employee?.department?.name
                            )
                            .filter(Boolean)
                            .filter((v, i, a) => a.indexOf(v) === i)
                            .join(', ') || '–'}
                        </div>
                    </div>

                    {/* Zamestnanec */}
                    <div>
                        <label className="block text-md font-semibold text-gray-800">Zamestnanec</label>
                        <div className="block w-full px-4 py-2 mt-1 border rounded-md bg-gray-100 text-gray-700">
                        {(checklist_template?.users || [])
                            .map(user => user?.employee?.name || user?.username)
                            .filter(Boolean)
                            .join(', ') || '–'}
                        </div>
                    </div>
                    </div>

                    <div className="md:col-span-2 grid grid-cols-1 sm:grid-cols-2 gap-6">
                        {/* Zodpovedný vedúci */}
                        <div>
                        <label className="block text-md font-semibold text-gray-800">{t('Checklist.ResponsibleManager')}</label>
                        <div className="block w-full px-4 py-2 mt-1 border rounded-md bg-gray-100 text-gray-700">
                            {(state?.users || [])
                            .filter(user => user?.id == checklist_template?.manager_id)
                            .map(user => user?.employee?.name || user?.username)
                            .join(', ') || '–'}
                        </div>
                        </div>

                        {/* Dni na vyjadrenie */}
                        <div>
                        <label className="block text-md font-semibold text-gray-800">Dni na vyjadrenie</label>
                        <div className="block w-full px-4 py-2 mt-1 border rounded-md bg-gray-100 text-gray-700">
                            {checklist_template?.manager_due_days || '–'}
                        </div>
                        </div>
                    </div>
                </AccordionTab>
            </Accordion>

            {/* Otázky */}
            <div className="space-y-6">
                {selectedRecord?.questions?.map((q, idx) => {
                    const modes = typeof q.answer_modes === "string" 
                        ? JSON.parse(q.answer_modes || '{}') 
                        : (q.answer_modes || {});
                    const fieldName = `answers[${idx}]`;
                    const answer = formikUpdate.values.answers?.[idx] || {};

                    const relevantEmployees = Array.isArray(modes.priorityDepartments) && modes.priorityDepartments.length > 0
                        ? state?.employees?.filter(emp => emp?.date_of_departure==null || emp?.date_of_departure=="")?.filter(employee => modes.priorityDepartments.includes(employee?.department_id))
                        : state?.employees?.filter(emp => emp?.date_of_departure==null || emp?.date_of_departure=="");

                    return (
                        <div key={idx} className="mb-6 border rounded-md bg-gray-50 p-4 shadow-sm">
                            {/* Otázka */}
                            <div className="flex items-start gap-3 mb-3">
                                <div className="flex-shrink-0 pt-2 text-md font-semibold text-gray-700">{idx + 1}.</div>
                                <InputTextarea
                                autoResize
                                readOnly
                                placeholder={t('Checklist.QuestionN', { n: idx + 1 })}
                                value={q.text}
                                className="w-full px-3 py-2 text-sm bg-gray-200 border rounded-md"
                                />
                            </div>

                            {/* OK/NOK/NO v jednom riadku */}
                            {(modes.okNok || modes.no) && (
                            <div className="flex gap-6 items-center mb-3">
                                {modes.okNok && (
                                    <>
                                    <div className="flex items-center gap-2">
                                        <RadioButton
                                        inputId={`ok-${idx}`}
                                        name={`answers.${idx}.okNokAnswer`}
                                        value="ok"
                                        checked={answer.okNokAnswer === 'ok'}
                                        disabled={selectedRecord?.save_mode=="save"}
                                        className="custom-radio"
                                        onChange={(e) =>
                                            formikUpdate.setFieldValue(`answers.${idx}.okNokAnswer`, e.value)
                                        }
                                        />
                                        <label htmlFor={`ok-${idx}`} className="text-sm">OK</label>
                                    </div>

                                    <div className="flex items-center gap-2">
                                        <RadioButton
                                        inputId={`nok-${idx}`}
                                        name={`answers.${idx}.okNokAnswer`}
                                        value="nok"
                                        checked={answer.okNokAnswer === 'nok'}
                                        disabled={selectedRecord?.save_mode=="save"}
                                        className="custom-radio"
                                        onChange={(e) =>
                                            formikUpdate.setFieldValue(`answers.${idx}.okNokAnswer`, e.value)
                                        }
                                        />
                                        <label htmlFor={`nok-${idx}`} className="text-sm">NOK</label>
                                    </div>
                                    </>
                                )}

                                {modes.no && (
                                    <div className="flex items-center gap-2">
                                    <RadioButton
                                        inputId={`no-${idx}`}
                                        name={`answers.${idx}.okNokAnswer`}
                                        value="no"
                                        checked={answer.okNokAnswer === 'no'}
                                        disabled={selectedRecord?.save_mode=="save"}
                                        className="custom-radio"
                                        onChange={(e) => {
                                        formikUpdate.setFieldValue(`answers.${idx}.okNokAnswer`, e.value);
                                        formikUpdate.setFieldValue(`answers.${idx}.photos`, []); // Reset fotiek
                                        }}
                                    />
                                    <label htmlFor={`no-${idx}`} className="text-sm">NO</label>
                                    </div>
                                )}
                            </div>
                            )}
                            {formikUpdate.errors?.answers?.[idx]?.okNokAnswer && (<div className="text-red-500 text-sm mt-2">{formikUpdate.errors.answers[idx].okNokAnswer}</div>)}

                            {/* Poznámky k OK / NOK / NO */}
                            {Array.isArray(formikUpdate.values?.answers) && modes.okNote && formikUpdate.values.answers[idx]?.okNokAnswer === 'ok' && (
                                <div className="mb-3">
                                    <InputTextarea
                                    name={`answers.${idx}.okNote`}
                                    value={formikUpdate.values.answers[idx]?.okNote || ''}
                                    onChange={formikUpdate.handleChange}
                                    disabled={selectedRecord?.save_mode=="save"}
                                    className="w-full text-sm border rounded-md"
                                    placeholder={t('Checklist.NoteOK')}
                                    />
                                    {formikUpdate.errors?.answers?.[idx]?.okNote && <div className="text-red-500 text-sm mt-1">{formikUpdate.errors?.answers?.[idx]?.okNote}</div>}
                                </div>
                            )}
                            {Array.isArray(formikUpdate.values?.answers) && modes.nokNote && formikUpdate.values.answers[idx]?.okNokAnswer === 'nok' && (
                                <div className="mb-3">
                                    <InputTextarea
                                    name={`answers.${idx}.nokNote`}
                                    value={formikUpdate.values.answers[idx]?.nokNote || ''}
                                    onChange={formikUpdate.handleChange}
                                    disabled={selectedRecord?.save_mode=="save"}
                                    className="w-full mb-3 text-sm border rounded-md"
                                    placeholder={t('Checklist.NoteNOK')}
                                    />
                                    {formikUpdate.errors?.answers?.[idx]?.nokNote && <div className="text-red-500 text-sm mt-1">{formikUpdate.errors?.answers?.[idx]?.nokNote}</div>}
                                </div>
                            )}
                            {Array.isArray(formikUpdate.values?.answers) && modes.noNote && answer.okNokAnswer === 'no' && (
                            <div className="mb-3">
                                <InputTextarea
                                name={`answers.${idx}.noNote`}
                                value={formikUpdate.values.answers[idx]?.noNote || ''}
                                onChange={formikUpdate.handleChange}
                                disabled={selectedRecord?.save_mode=="save"}
                                className="w-full mb-3 text-sm border rounded-md"
                                placeholder={t('Checklist.NoteNO')}
                                required
                                />
                                {formikUpdate.errors?.answers?.[idx]?.noNote && (<div className="text-red-500 text-sm mt-1">{formikUpdate.errors?.answers?.[idx]?.noNote}</div>)}
                            </div>
                            )}

                            {images?.some(img => img.question_id == idx) && (
                            <div className="mb-4">
                                <label className="block text-md font-semibold text-gray-800 mb-2">{t('Checklist.Gallery')}</label>
                                {images.map((img, i) =>  {
                                if(img?.question_id != idx)return "";
                                return <table key={i} className="w-full border border-separate border-gray-400 rounded-md bg-white mb-4">
                                    <tbody>
                                    <tr>
                                        <td className="text-black h-10">
                                        <div className="flex flex-row p-2 items-center">
                                            <div onClick={() => openFilePreview({ url: img.url, filename: img.filename })} className="cursor-pointer">
                                            {/\.(pdf|png|jpg|jpeg|gif|webp|bmp|svg|img)$/i.test(img.filename || '') ? (
                                                <embed src={`${img.url}#view=FitH&scrollbar=0`} width="100px" height="65px" type="application/pdf" />
                                            ) : (
                                                <div className="w-[100px] h-[65px] flex items-center justify-center bg-gray-100 border rounded"><PaperClipIcon /></div>
                                            )}
                                            </div>
                                            <div className="flex flex-col ml-4">
                                            <a
                                                style={{ color: 'blue', cursor: 'pointer', marginBottom: '2px' }}
                                                onClick={() => openFilePreview({ url: img.url, filename: img.filename })}
                                            >
                                                {img.filename}
                                            </a>
                                            <button
                                                type="button"
                                                disabled={selectedRecord?.save_mode=="save"}
                                                className="w-fit flex flex-row px-2 py-1 border rounded-md bg-red-900 text-white"
                                                onClick={() => deleteFiles(img)}
                                            >
                                                <DeleteIcon />
                                                <span className="ml-1">{t('Common.Clear')}</span>
                                            </button>
                                            </div>
                                        </div>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            })}
                            </div>
                            )}

                            {/* Meno zamestnanca + Foto v jednom riadku */}
                            {Array.isArray(formikUpdate.values?.answers) && (modes.name || modes.photo || modes?.optional_photo) && (
                                <div className="flex flex-col sm:flex-row gap-4">
                                {(modes.name && answer.okNokAnswer != 'no') && (
                                    <div className="flex-1">
                                    <label className="block text-sm font-medium text-gray-700 mb-1">
                                        Vyber meno zamestnanca<span className="text-red-500">*</span>
                                    </label>
                                    <select
                                        name={`${fieldName}.employeeId`}
                                        value={answer.employeeId || ''}
                                        onChange={(e) => formikUpdate.setFieldValue(`${fieldName}.employeeId`, e.target.value)}
                                        disabled={selectedRecord?.save_mode=="save"}
                                        className="w-full border rounded-md px-2 py-1 text-sm"
                                    >
                                        <option value="">-- Vyber zamestnanca --</option>
                                        {relevantEmployees.map(user => (
                                        <option key={user.id} value={user.id}>{user.name}</option>
                                        ))}
                                    </select>
                                    {formikUpdate.errors?.answers?.[idx]?.employeeId && <div className="text-red-500 text-sm mt-1">{formikUpdate.errors?.answers?.[idx]?.employeeId}</div>}
                                    </div>
                                )}
                                {((modes.photo && answer.okNokAnswer != 'no') || modes?.optional_photo) && (
                                <div className="flex-1">
                                    <label className="block text-sm font-medium text-gray-700 mb-1">
                                    Prilož fotografie{modes?.photo ? (<span className="text-red-500">*</span>): (<span className="text-gray-500">{t('Common.OptionalParen')}</span>)}                                    </label>
                                    <input
                                    type="file"
                                    name={`${fieldName}.photos`}
                                    multiple
                                    accept="image/*"
                                    onChange={(e) =>
                                        formikUpdate.setFieldValue(`${fieldName}.photos`, e.currentTarget.files)
                                    }
                                    className="w-full text-sm"
                                    disabled={selectedRecord?.save_mode=="save"}
                                    />
                                    {formikUpdate.errors?.answers?.[idx]?.photos && (
                                    <div className="text-red-500 text-sm mt-1">{formikUpdate.errors?.answers?.[idx]?.photos}</div>
                                    )}
                                </div>
                                )}
                                </div>
                            )}
                        </div>
                    );
                })}
            </div>

            <div className="flex gap-3 mt-6">
                <button
                    type="button"
                    disabled={selectedRecord?.save_mode=="save"}
                    onClick={() => {
                        formikUpdate.setFieldValue('save_mode', 'draft');
                        setPendingSubmit("update");
                    }}
                    className="w-full h-10 font-medium px-2 py-1 tracking-wide text-gray-800 bg-yellow-200 border border-yellow-300 rounded-md hover:bg-yellow-300 disabled:opacity-25"
                >
                    Uložiť koncept
                </button>

                <button
                    type="button"
                    disabled={selectedRecord?.save_mode=="save"}
                    onClick={() => {
                        formikUpdate.setFieldValue('save_mode', 'save');
                        setPendingSubmit("update");
                    }}
                    className="w-full h-10 font-medium px-2 py-1 tracking-wide text-white bg-zinc-900 rounded-md hover:bg-zinc-700 disabled:opacity-25"
                >
                    Uložiť
                </button>
            </div>
        </form>
      </Dialog>
      <Dialog header={t('Common.SetMask')} visible={maskVisible} style={{ width: '70vw' }} onHide={() => setMaskVisible(false)}>
        <div className="flex flex-col">
        <button type="button" onClick={() => {changeMarkings(!markUnmark);setMarkUnmarked(!markUnmark);}} className='m-1 px-4 py-2 text-center tracking-wide text-white transition-colors duration-200 transform bg-zinc-700 rounded-md hover:bg-zinc-500'>{markUnmark ? t('Common.DeselectAllUpper') : t('Common.SelectAllUpper')}</button>
        {columns.map(function(item, index){ 
          if(index<2) return null;
                    return <div 
                        key={index} 
                        className="flex flex-row border border-black rounded-md p-2 m-1"
                    > 

                         <Checkbox onChange={(e) => setMask(item.field,e.checked)} checked={columnsVisible[item.field]}></Checkbox><span className="ml-2">{item.title}</span>
                          
                        {/* Use the React icon component */} 
                    </div> 
                })} 
            <button onClick={() => {setUserMaskFilter("ChecklistRecordAdd","set_columns",columnsVisible,null,null);setMaskVisible(false);}} className='m-1 px-4 py-2 text-center tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600'>{t('Ui.R67.SaveUpper')}</button>
        </div>
      </Dialog>
        
            </> 
            );
} 
